export default __webpack_public_path__ + "static/BeatriceBold-ce787af2e1947da28c455fe2acb3ed17.otf";